import React from 'react'
import { useTheme } from '@mui/material'
import { FieldArray, ErrorMessage } from 'formik'
import { Box, Typography, InputAdornment, Divider, Card, Icon, useMediaQuery } from '@mui/material'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxInput from 'components/custom/AdxInput'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxDatePicker from 'components/custom/AdxDatePicker'
import AdxButton from 'components/custom/AdxButton'

const residentStatusDropdown = [
  {
    id: 1,
    description: 'Resident',
  },
  {
    id: 2,
    description: 'Non-Resident',
  },
  {
    id: 3,
    description: 'Returning Expert Program (REP)',
  },
  {
    id: 4,
    description: 'Knowledge Worker (IRDA)',
  },
  {
    id: 5,
    description: 'C suites',
  },
]

const marriageStatusDropdown = [
  {
    id: 1,
    name: 'Single',
  },
  {
    id: 2,
    name: 'Married But Spouse Not Working',
  },
  {
    id: 3,
    name: 'Married But Spouse Working',
  },
  {
    id: 4,
    name: 'Divorced/Widow/Widower',
  },
]

const educationDropdown = [
  {
    id: 0,
    education: 'No Education',
  },
  {
    id: 1,
    education: 'High school & below',
  },
  {
    id: 2,
    education: 'Diploma (Local) or Higher',
  },
  {
    id: 3,
    education: 'Degree (Overseas) or Higher',
  },
]

const EditTaxTab = ({ formikBag }) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))

  const { values, handleChange, handleBlur, setFieldValue, touched, errors } = formikBag
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box>
        <Box
          p={1.75}
          display="flex"
          justifyContent="space-between"
          borderBottom="1px solid"
          sx={{ borderColor: 'gray-line.main' }}
          alignItems="center"
        >
          <Typography color="light-gray-text.main" fontWeight={500}>
            Tax details
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
          <Box gap={1} display="flex" justifyContent="space-between" alignItems="flex-end">
            <AdxDropdown
              label="Tax Residency Status"
              name="resident_status"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.resident_status}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              errorMessage={<ErrorMessage name="resident_status" component={AdxErrorMessage} />}
              isErrorShown={touched.resident_status && errors.resident_status}
              sx={{ width: { xs: '100%', sm: '60%' } }}
            >
              {residentStatusDropdown.map((status) => (
                <AdxMenuItem value={status.id} selectedvalue={values.resident_status}>
                  {status.description}
                </AdxMenuItem>
              ))}
            </AdxDropdown>
          </Box>
          <Box gap={2.5} display="flex" justifyContent="space-between">
            <AdxInput
              label="Income Tax Number"
              name="income_tax_number"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.income_tax_number}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="Income Tax Number"
              errorMessage={<ErrorMessage name="income_tax_number" component={AdxErrorMessage} />}
              isErrorShown={touched.income_tax_number && errors.income_tax_number}
              sx={{ width: '100%' }}
            />
          </Box>
          <Box gap={2.5} display="flex" mb={0.5}>
            <AdxInput
              label="Previous Months MTD"
              name="previous_mtd"
              value={values.previous_mtd}
              onChange={handleChange}
              onBlur={handleBlur}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="Previous Months MTD"
              errorMessage={<ErrorMessage name="previous_mtd" component={AdxErrorMessage} />}
              isErrorShown={touched.previous_mtd && errors.previous_mtd}
              startAdornment={<InputAdornment position="start">RM</InputAdornment>}
              sx={{ width: { xs: '100%', sm: '60%' } }}
            />
          </Box>
          <Box gap={2.5} display="flex" mb={0.5}>
            <AdxInput
              label="Accumulated Months EPF Contribution"
              name="epf_contribution"
              value={values.epf_contribution}
              onChange={handleChange}
              onBlur={handleBlur}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="Accumulated Months EPF Contribution"
              errorMessage={<ErrorMessage name="epf_contribution" component={AdxErrorMessage} />}
              isErrorShown={touched.epf_contribution && errors.epf_contribution}
              startAdornment={<InputAdornment position="start">RM</InputAdornment>}
              sx={{ width: { xs: '100%', sm: '60%' } }}
            />
          </Box>
          <Box gap={2.5} display="flex" mb={0.5}>
            <AdxInput
              label="Accumulated Months Gross Remuneration"
              name="gross_remuneration"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.gross_remuneration}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="Accumulated Months Gross Remuneration"
              errorMessage={<ErrorMessage name="gross_remuneration" component={AdxErrorMessage} />}
              isErrorShown={touched.gross_remuneration && errors.gross_remuneration}
              startAdornment={<InputAdornment position="start">RM</InputAdornment>}
              sx={{ width: { xs: '100%', sm: '60%' } }}
            />
          </Box>
        </Box>
      </Box>

      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid',
            borderColor: 'gray-line.main',
            p: 2,
            alignItems: 'center',
          }}
        >
          <Typography color="light-gray-text.main" fontWeight={500}>
            Household
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
          <Box>
            <AdxDropdown
              label="Marriage Status"
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="Marriage Status"
              name="marriage_status"
              value={values.marriage_status}
              onChange={(event) => {
                if (event.target.value === 1 || event.target.value === 4) {
                  if (values.marriage_status !== 1 || values.marriage_status !== 4) {
                    setFieldValue('spouse_disability_status', 0)
                  }
                } else {
                  if (values.marriage_status === 1 || values.marriage_status === 4) {
                    setFieldValue('spouse_disability_status', null)
                  }
                }
                handleChange(event)
              }}
              onBlur={handleBlur}
              sx={{ width: { xs: '100%', sm: '60%' } }}
              errorMessage={<ErrorMessage name="marriage_status" component={AdxErrorMessage} />}
              isErrorShown={touched.marriage_status && errors.marriage_status}
            >
              {marriageStatusDropdown.map((status) => (
                <AdxMenuItem value={status.id} selectedvalue={values.marriage_status}>
                  {status.name}
                </AdxMenuItem>
              ))}
            </AdxDropdown>
          </Box>
          <Box>
            <AdxDropdown
              label="Spouse Disability Status"
              disabled={values.marriage_status === 1 || values.marriage_status === 4}
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              placeholder="Spouse Disability Status"
              value={values.spouse_disability_status}
              name="spouse_disability_status"
              onChange={handleChange}
              onBlur={handleBlur}
              sx={{ width: { xs: '100%', sm: '30%' } }}
              errorMessage={
                <ErrorMessage name="spouse_disability_status" component={AdxErrorMessage} />
              }
              isErrorShown={touched.spouse_disability_status && errors.spouse_disability_status}
            >
              <AdxMenuItem value={1} selectedvalue={values.spouse_disability_status}>
                Yes
              </AdxMenuItem>
              <AdxMenuItem value={0} selectedvalue={values.spouse_disability_status}>
                No
              </AdxMenuItem>
            </AdxDropdown>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              columnGap: 1,
            }}
          >
            <AdxInput
              label="Number of Children"
              disabled
              sxLabel={{
                color: 'dark-text.main' /*, fontSize: "30px!important" */,
              }}
              sxInput={{
                color: 'light-gray-text.main',
                backgroundColor: 'white.main',
              }}
              size="standard"
              type="number"
              placeholder="Number of Children"
              value={values.children.length}
              sx={{ width: { xs: '100%', sm: '44%' } }}
            />
            <Typography variant="body1" sx={{ width: '100%' }}>
              Describe something about eligible children here
            </Typography>
          </Box>
          <Box>
            <Card variant="outlined" sx={{ width: '100%', minHeight: '150px' }}>
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: 'center',
                  columnGap: 2.5,
                  p: 2,
                }}
              >
                {matches ? <Box sx={{ width: 1 / 4 }}></Box> : null}
                <Box
                  sx={{
                    display: 'flex',
                    width: { xs: 1, sm: 3 / 4 },
                    alignItems: 'center',
                    columnGap: 2.5,
                  }}
                >
                  <Box sx={{ width: { xs: 1 / 3, sm: 1.5 / 5 } }}>
                    <Typography align="center" variant="body1" color="dark-gray-text.main">
                      Date of birth
                    </Typography>
                  </Box>
                  <Box sx={{ width: { xs: 1 / 3, sm: 2 / 5 } }}>
                    <Typography align="center" variant="body1" color="dark-gray-text.main">
                      Education Status
                    </Typography>
                  </Box>
                  <Box sx={{ width: { xs: 1 / 3, sm: 1.5 / 5 } }}>
                    <Typography align="center" variant="body1" color="dark-gray-text.main">
                      Disability Status
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Divider light />
              <FieldArray
                name="children"
                render={(arrayHelpers) => {
                  return (
                    <>
                      {values.children.map((item, index) => {
                        return (
                          <Box
                            key={index}
                            sx={{
                              display: 'flex',
                              width: '100%',
                              flexDirection: { xs: 'column', sm: 'row' },
                              alignItems: 'center',
                              gap: 1,
                              p: 2,
                            }}
                          >
                            <Box sx={{ width: 1 / 4 }}>
                              <Typography variant="body1" color="dark-gray-text.main">
                                Child {index + 1}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                width: { xs: 1, sm: 3 / 4 },
                                alignItems: 'center',
                                columnGap: 1,
                                justifyContent: 'center',
                              }}
                            >
                              <Box sx={{ width: { xs: 1 / 3, sm: 1.5 / 5 } }}>
                                <AdxDatePicker
                                  onChange={(e) => setFieldValue(`children[${index}].dob`, e)}
                                  name={`children[${index}].dob`}
                                  value={values.children[index].dob}
                                  disableFuture
                                  errorMessage={
                                    <ErrorMessage
                                      name={`children[${index}].dob`}
                                      component={AdxErrorMessage}
                                    />
                                  }
                                  isErrorShown={
                                    touched.children &&
                                    errors.children &&
                                    touched.children[index]?.dob &&
                                    errors.children[index]?.dob
                                  }
                                />
                              </Box>
                              <Box sx={{ width: { xs: 1 / 3, sm: 2 / 5 } }}>
                                <AdxDropdown
                                  name={`children[${index}].education_status`}
                                  sxLabel={{
                                    color: 'dark-text.main',
                                  }}
                                  sxInput={{
                                    color: 'light-gray-text.main',
                                    backgroundColor: 'white.main',
                                  }}
                                  size="standard"
                                  value={values.children[index].education_status}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  errorMessage={
                                    <ErrorMessage
                                      name={`children[${index}].education_status`}
                                      component={AdxErrorMessage}
                                    />
                                  }
                                  isErrorShown={
                                    touched.children &&
                                    errors.children &&
                                    touched.children[index]?.education_status &&
                                    errors.children[index]?.education_status
                                  }
                                  sx={{ width: { xs: '100%', sm: '100%' } }}
                                >
                                  {educationDropdown.map((dropdown) => (
                                    <AdxMenuItem
                                      value={dropdown.id}
                                      selectedvalue={values.children.education_status}
                                    >
                                      {dropdown.education}
                                    </AdxMenuItem>
                                  ))}
                                </AdxDropdown>
                              </Box>
                              <Box sx={{ width: { xs: 1 / 3, sm: 1 / 5 } }}>
                                <AdxDropdown
                                  name={`children[${index}].disability_status`}
                                  sxLabel={{
                                    color: 'dark-text.main',
                                  }}
                                  sxInput={{
                                    color: 'light-gray-text.main',
                                    backgroundColor: 'white.main',
                                  }}
                                  size="standard"
                                  value={values.children[index].disability_status}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  errorMessage={
                                    <ErrorMessage
                                      name={`children[${index}].disability_status`}
                                      component={AdxErrorMessage}
                                    />
                                  }
                                  isErrorShown={
                                    touched.children &&
                                    errors.children &&
                                    touched.children[index]?.disability_status &&
                                    errors.children[index]?.disability_status
                                  }
                                  sx={{ width: { xs: '100%', sm: '100%' } }}
                                >
                                  <AdxMenuItem value={1} selectedvalue={values.children.disability}>
                                    Yes
                                  </AdxMenuItem>
                                  <AdxMenuItem value={0} selectedvalue={values.children.disability}>
                                    No
                                  </AdxMenuItem>
                                </AdxDropdown>
                              </Box>

                              <Box
                                display="flex"
                                alignItems="center"
                                sx={{ cursor: 'pointer' }}
                                onClick={() => {
                                  arrayHelpers.remove(index)
                                }}
                              >
                                <RemoveCircleIcon
                                  sx={{
                                    fontSize: 20,
                                    marginRight: -2,
                                  }}
                                  color="error"
                                />
                              </Box>
                            </Box>
                          </Box>
                        )
                      })}

                      <Box
                        sx={{ width: '100%', p: 0.5, borderTop: 1, borderColor: 'gray-line.main' }}
                      >
                        <AdxButton
                          variant={'ghost'}
                          fullWidth
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 1,
                          }}
                          onClick={() => {
                            arrayHelpers.push({
                              dob: null,
                              education_status: null,
                              disability_status: null,
                            })
                          }}
                        >
                          <Icon
                            sx={{
                              fontSize: 24,
                              color: 'alternate.main',
                              mr: 1,
                            }}
                          >
                            add
                          </Icon>
                          <Typography variant="body1">Add Children</Typography>
                        </AdxButton>
                      </Box>
                    </>
                  )
                }}
              />
            </Card>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EditTaxTab
